import { render, staticRenderFns } from "./basics-list.vue?vue&type=template&id=2eb7dd18&scoped=true"
import script from "./basics-list.vue?vue&type=script&lang=js"
export * from "./basics-list.vue?vue&type=script&lang=js"
import style0 from "./basics-list.vue?vue&type=style&index=0&id=2eb7dd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7dd18",
  null
  
)

export default component.exports